import { render, staticRenderFns } from "./VoterForm.vue?vue&type=template&id=9f0f7952&"
import script from "./VoterForm.vue?vue&type=script&lang=js&"
export * from "./VoterForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports